import { Image, type PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { FC } from 'react';

const icons = {
  facebook: {
    src: '/assets/icons/icon-facebook.svg',
    alt: 'Facebook',
  },
  youtube: {
    src: '/assets/icons/icon-youtube.svg',
    alt: 'Youtube',
  },
  instagram: {
    src: '/assets/icons/icon-instagram-dark.svg',
    alt: 'Instagram',
  },
};

interface LinkProps extends PropsWithClassProps {
  type: 'facebook' | 'youtube' | 'instagram';
  url: string;
  width: number;
  height: number;
}

export const SocialLink: FC<LinkProps> = ({ type, classProps, url, width, height }) => {
  const icon = icons[type];

  return (
    <a
      className={`${classProps?.root || ''} flex cursor-pointer items-center hover:opacity-50`}
      target={'_blank'}
      aria-label={icon.alt}
      href={url || ''}
      rel="noreferrer"
    >
      <Image src={icon.src} alt={icon.alt} width={width} height={height} copyright="" placeholder="empty" />
    </a>
  );
};
